import React, { Suspense } from "react";
import { createMedia } from "@artsy/fresnel";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Footer from "../components/Footer";

import DesktopContainer from "./DesktopContainer";
import MobileContainer from "./MobileContainer";

import Home from "../pages/home";
import Contact from "../pages/contact";
import Career from "../pages/career";
import Company from "../pages/company";
import MyProperties from "../pages/my-properties";
import PropertyListing from "../pages/propertyListing";
import Detail from "../pages/detail";
import DynamicPage from "../pages/dynamicPage";
import Blog from "../pages/blog";
import BlogPost from "../pages/blogPost";
import Agent from "../pages/agent";
import AgentsList from "../pages/agentsList";
import { pageEnum } from "../Common";
import ThankYouPage from "../pages/home/ThankYou";
export const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

export const MENU_ITEMS = [
  { name: "Home", url: "/" },
  { name: "Residentials", url: "/residentials" },
  { name: "Commercials", url: "/commercials" },
  { name: "Agents", url: "/agents" },
  { name: "Careers", url: "/career" },
  { name: "Blog", url: "/blog" },
  { name: "Contact Us", url: "/contact" },
  { name: "Add My Properties", url: "/my-properties" }
];

const ResponsiveContainer = ({ children }) => (
  <MediaContextProvider>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </MediaContextProvider>
);

function Router() {

  return (
    <BrowserRouter>
      <ResponsiveContainer>
        <div /* style={{ minHeight: '100vh' }} */>
          <Switch>
            <Route path="/career">
              <Career />
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>
            <Route path="/company">
              <Company />
            </Route>
            <Route path="/my-properties">
              <MyProperties />
            </Route>
            <Route path="/thankyou">
              <ThankYouPage />
            </Route>
            <Route path="/thankyou-myproperty">
              <ThankYouPage />
            </Route>
            <Route path="/thankyou-career">
              <ThankYouPage />
            </Route>
            <Route path="/thankyou-contact">
              <ThankYouPage />
            </Route>
            <Route path="/thankyou-contactagent">
              <ThankYouPage />
            </Route>
            <Route path="/thankyou-requestviewing">
              <ThankYouPage />
            </Route>
            {/* <Route path="/detail/:id/:type" children={<Detail />}></Route> */}
            <Route
              path="/residentials"
              render={() => (
                <Suspense fallback={<div>loading...</div>}></Suspense>
              )}
            >
              <PropertyListing pageNumber={pageEnum.Residentials} />
            </Route>
            <Route
              path="/commercials"
              render={() => (
                <Suspense fallback={<div>loading...</div>}></Suspense>
              )}
            >
              <PropertyListing pageNumber={pageEnum.Commercials} />
            </Route>
            <Route path="/agents" children={<AgentsList />} />
            <Route path="/agent/:id" children={<Agent />} />
            <Route path="/blog/:slug" children={<BlogPost />} />
            <Route path="/blog" children={<Blog />} />
            <Route path="/:path" children={<DynamicPage />} />

            <Route path="/">
              <Home />
            </Route>
          </Switch>
        </div>
        <Footer />
      </ResponsiveContainer>
    </BrowserRouter>
  );
}

export default Router;
